import { Component } from "react";

class Screen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backwardPressedAMomentAgo: false
    };
  }

  componentDidMount() {
    if (this.props.content.length !== 0) {
      this.startTimeOut(this.props.currentIndex);
    }
    if (this.props.forwardRef.current) {
      if (this.props.playlistPlayedDuration) {
        this.props.forwardRef.current.currentTime = this.props.playlistPlayedDuration;
      } else {
        this.props.forwardRef.current.currentTime = this.props.playedDuration;
      }
      this.props.forwardRef.current.play();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isForward === true) {
      this.stopTimeOut();
      const duration = this.calculateDurationForForward(
        this.props.content,
        nextProps
      );
      this.props.resetForwardAndBackward();
    }
    if (nextProps.isBackward === true) {
      this.stopTimeOut();
      const duration = this.backwardCalculateDuration(
        this.props.content,
        nextProps
      );
      this.props.resetForwardAndBackward();
    }
  }

  componentWillUnmount() {
    this.stopTimeOut();
  }

  stopTimeOut = () => {
    clearTimeout(this.timeoutID);
    if (this.props.selectedPLC) {
      this.props.selectedPLC.forEach((i, index) => {
        clearTimeout(this[`playlistTimeOut-${index}`]);
      });
    }
  };

  timer = (newIndex, playDurn) =>
    setTimeout(() => {
      this.props.resetPlaylistIndex();
      this.props.resetPlayedDuration();
      this.startTimeOut(newIndex);
    }, playDurn * 1000);

  playlistTimer = (index, total, selectedPLC) =>
    setTimeout(() => {
      if (index > 0) {
        this.props.handlePlaylistIndex(index);
        // if (index === selectedPLC.length - 1) {
        //   this.props.resetSelectedPlaylist();
        // }
      }
    }, total * 1000);

  calculateDurationForForward = async (content, { startTime, forwardTime }) => {
    let playedDuration;
    let { selectedPLC } = this.props;
    playedDuration =
      this.props.playedDuration + forwardTime.diff(startTime, "second") + 5;
    this.props.setNewIndexAndPlayedDuration(
      this.props.currentIndex,
      playedDuration
    );
    let playlistDuration;
    let contentDuration;
    let newIndex = this.props.currentIndex;

    if (content[newIndex].plHook) {
      // if (selectedPLC) {
      // might need to remove dependency from selected PLC
      /* if there is already a previous PLC available ,then get that PLC  */
      const oldIndexPreviousPlaylistContent = await content[
        newIndex
      ].getPreviousStateContent();

      if (oldIndexPreviousPlaylistContent.length > 0) {
        selectedPLC = oldIndexPreviousPlaylistContent;
      }
      // else {
      //   selectedPLC = content[newIndex].plHook && selectedPLC;
      // }
      // }
      else {
        // this.props.resetSelectedPlaylist();
        selectedPLC =
          content[newIndex].plHook && (await content[newIndex].getContent());
      }
      this.props.setSelectedPlc(selectedPLC);
      playlistDuration = selectedPLC.reduce(
        (total, plc) => total + plc.duration,
        0
      );

      contentDuration = playlistDuration;
    } else {
      contentDuration = content[newIndex].duration;
    }

    while (contentDuration < playedDuration) {
      const shouldBeZero = content.length - 1 === newIndex;
      playedDuration -= contentDuration;
      newIndex = shouldBeZero ? 0 : newIndex + 1;

      if (content[newIndex].plHook) {
        selectedPLC =
          content[newIndex].plHook && (await content[newIndex].getContent());

        playlistDuration = selectedPLC.reduce(
          (total, plc) => total + plc.duration,
          0
        );

        contentDuration = playlistDuration;
        this.props.setSelectedPlc(selectedPLC);
      } else {
        // this.props.resetSelectedPlaylist();
        contentDuration = content[newIndex].duration;
      }

      this.props.setNewIndexAndPlayedDuration(newIndex, playedDuration);
    }
    const isForward = true;
    const isBackward = false;

    if (this.props.content.length !== 0) {
      this.startTimeOut(newIndex, playedDuration, isForward, isBackward);
    }
    this.setForwardRef(playedDuration);
    return { playedDuration, newIndex };
  };

  calculatePlaylistDuration = (content, pDuration, isForward, isBackward) => {
    /* content is selected playlist content */
    /* remainingTimeToBePlayed is the remaining time for the next playlist content to play */
    let remainingTimeToBePlayed = pDuration;
    let newIndex = this.props.playlistIndex;
    /* if new Index is zero, look out for the side effects */

    let i = 0;

    if (isForward) {
      while (content.length > i) {
        /* HERE the playlist index is manipulated */

        if (content[i].duration < remainingTimeToBePlayed) {
          newIndex = i + 1;
          /* the final remaining playlist played duration is actually the remaining time for the selected PLC to play */
          remainingTimeToBePlayed -= content[i].duration;
        } else if (i === 0 && remainingTimeToBePlayed < content[i].duration) {
          /* SPECIAL CASE
          while rewinding, if the remaingDuration is less than the first content duration, index was not set to the initial index

          so to set to the initial point, if the first content doesn't fill up the remaining duration then the index is set to 0
          */
          newIndex = 0;
          break;
        }

        i++;
      }
    }
    if (isBackward) {
      while (content.length > i) {
        /* HERE the playlist index is manipulated */

        if (content[i].duration < remainingTimeToBePlayed) {
          newIndex = i + 1;
          /* the final remaining playlist played duration is actually the remaining time for the selected PLC to play */
          remainingTimeToBePlayed -= content[i].duration;
        } else if (i === 0 && remainingTimeToBePlayed < content[i].duration) {
          /* SPECIAL CASE
          while rewinding, if the remaingDuration is less than the first content duration, index was not set to the initial index

          so to set to the initial point, if the first content doesn't fill up the remaining duration then the index is set to 0
          */
          newIndex = 0;
          break;
        }

        i++;
      }
    }

    this.props.setPlaylistPlayedTime(remainingTimeToBePlayed);
    /* this will set the index that is to play */
    this.props.setPlaylistIndexOnly(newIndex);

    content.reduce((total, plc, index) => {
      const { duration } = plc;
      let nextPlayTime;
      if (index >= newIndex) {
        let newPlaylistDuration;
        if (newIndex === index) {
          newPlaylistDuration = duration - remainingTimeToBePlayed;
        } else {
          /* if new index is greater than the index */
          this.props.resetPlaylistPlayedDuration();
          newPlaylistDuration = duration;
        }
        nextPlayTime = total + newPlaylistDuration;
        this[`playlistTimeOut-${index}`] = this.playlistTimer(index, total);
        return nextPlayTime;
      }
      return 0;
    }, 0);
  };

  /* sets the index and played duration needed for new content about to play */
  backwardCalculateDuration = async (content, { startTime, backwardTime }) => {
    let playedDuration;
    let { selectedPLC } = this.props;
    const contentPlayed =
      this.props.playedDuration + backwardTime.diff(startTime, "second");

    this.props.setNewIndexAndPlayedDuration(
      this.props.currentIndex,
      playedDuration
    );

    let newIndex = this.props.currentIndex;
    let playlistDuration;
    let contentDuration;

    if (contentPlayed > 5) {
      playedDuration = contentPlayed - 5;
    } else {
      let remainingDuration = 5 - contentPlayed;
      /* FINDS THE NEW INDEX AFTER PRESSING REWIND BUTTON */
      newIndex =
        newIndex === 0 ? content.length - 1 : this.props.currentIndex - 1;

      // Find if the content is playlist or not
      if (content[newIndex].plHook) {
        const oldIndexPreviousPlaylistContent =
          content[newIndex].plHook &&
          (await content[newIndex].getPreviousStateContent());
        if (oldIndexPreviousPlaylistContent) {
          /* removed dependency from selected PLC */
          /* this is very imp for backward to run dont touch */
          /* PLEASE CHANGE THE ELSE IF CONDITION TO ACCOMODATE FORWARD , BACKWARD+FORWARD */
          /*  NEED TO LOOK INTO THIS FOR MULTIPLE PLAYLIST, check selectedplc value */

          /* if the indexed content is a playlist and if the playlist was already played */
          selectedPLC = oldIndexPreviousPlaylistContent;
        } else {
          /* if the indexed content is a playlist and if the playlist was never played */

          this.props.resetSelectedPlaylist();
          selectedPLC =
            content[newIndex].plHook && (await content[newIndex].getContent());
        }

        this.props.setSelectedPlc(selectedPLC);
        playlistDuration = selectedPLC.reduce(
          (total, plc) => total + plc.duration,
          0
        );

        contentDuration = playlistDuration;
      } else {
        contentDuration = content[newIndex].duration;
      }

      while (contentDuration < remainingDuration) {
        /* new index is calculated hera after pressing the backward button */
        newIndex = newIndex === 0 ? content.length - 1 : newIndex - 1;
        remainingDuration -= contentDuration;
        // Get Playlist Index

        if (content[newIndex].plHook) {
          const oldIndexPreviousPlaylistContent =
            content[newIndex].plHook &&
            (await content[newIndex].getPreviousStateContent());
          if (oldIndexPreviousPlaylistContent) {
            /* removed dependency from selected PLC */
            /* this is very imp for backward to run dont touch */
            /* PLEASE CHANGE THE ELSE IF CONDITION TO ACCOMODATE FORWARD , BACKWARD+FORWARD */
            /*  NEED TO LOOK INTO THIS FOR MULTIPLE PLAYLIST, check selectedplc value */

            /* if the indexed content is a playlist and if the playlist was already played */
            selectedPLC = oldIndexPreviousPlaylistContent;
          } else {
            selectedPLC =
              content[newIndex].plHook &&
              (await content[newIndex].getContent());
          }
          playlistDuration = selectedPLC.reduce(
            (total, plc) => total + plc.duration,
            0
          );
          contentDuration = playlistDuration;
          this.props.setSelectedPlc(selectedPLC);
        } else {
          this.props.resetSelectedPlaylist();
          contentDuration = content[newIndex].duration;
        }
      }

      playedDuration = contentDuration - remainingDuration;
    }
    const isForward = false;
    const isBackward = true;
    this.props.setNewIndexAndPlayedDuration(newIndex, playedDuration);
    if (this.props.content.length !== 0) {
      this.startTimeOut(newIndex, playedDuration, isForward, isBackward);
    }
    this.setForwardRef(playedDuration);
    return { playedDuration, newIndex };
  };

  // For Video Timing while forward backward or play
  setForwardRef = duration => {
    if (this.props.forwardRef.current) {
      if (this.props.playlistPlayedDuration) {
        this.props.forwardRef.current.currentTime = this.props.playlistPlayedDuration;
      } else {
        this.props.forwardRef.current.currentTime = duration;
      }
      this.props.forwardRef.current.play();
    }
  };

  startTimeOut = async (oldIndex, durn = null, isForward, isBackward) => {
    // oldIndex is the index which is about to be played
    const s = this.props.content;
    const shouldBeZero = s.length - 1 === oldIndex;
    const newIndex = shouldBeZero ? 0 : oldIndex + 1;
    if (isBackward) {
      this.setState({ backwardPressedAMomentAgo: isBackward });
    }

    const oldIndexPreviousPlaylistContent =
      s[oldIndex].plHook && (await s[oldIndex].getPreviousStateContent());
    this.props.setStartTime();
    // let selectedPLC = s[oldIndex].plHook && (await s[oldIndex].getContent());
    let selectedPLC;

    /* ///////// THE SELCTION OF PLC STARTS HERE /////////////////// */
    if (this.props.pauseWasPressedAMomentAgo && s[oldIndex].plHook) {
      selectedPLC =
        oldIndexPreviousPlaylistContent &&
        oldIndexPreviousPlaylistContent.length > 0
          ? oldIndexPreviousPlaylistContent
          : await s[oldIndex].getContent();
      this.props.clearPauseWasPressedValue();
    } else if (s[oldIndex].plHook && isBackward) {
      /* if the index points to a playlist only then perform the following action  to select a PLC */
      if (
        oldIndexPreviousPlaylistContent &&
        oldIndexPreviousPlaylistContent.length > 0
      ) {
        /* removing dependency from selected PLC to get the previous played playlist content */
        /* this is very imp for backward to run dont touch */
        /* PLEASE CHANGE THE ELSE IF CONDITION TO ACCOMODATE FORWARD , BACKWARD+FORWARD */
        /*  NEED TO LOOK INTO THIS FOR MULTIPLE PLAYLIST, check selectedplc value */
        selectedPLC = oldIndexPreviousPlaylistContent;
      } else {
        /* if the indexed content is playlist and none of the above conditions met,
        then get the new PLC from the indexed playlist */
        selectedPLC = s[oldIndex].plHook && (await s[oldIndex].getContent());
      }
    } else if (s[oldIndex].plHook && isForward) {
      /* it is forward */
      // eslint-disable-next-line no-lonely-if
      if (
        oldIndexPreviousPlaylistContent &&
        oldIndexPreviousPlaylistContent.length > 0
      ) {
        selectedPLC = oldIndexPreviousPlaylistContent;
      } else {
        selectedPLC = s[oldIndex].plHook && (await s[oldIndex].getContent());
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (
        this.state.backwardPressedAMomentAgo &&
        s[oldIndex].plHook &&
        !(
          oldIndexPreviousPlaylistContent &&
          oldIndexPreviousPlaylistContent.length > 0
        )
      ) {
        /* If the indexed content is playlist , and if backward was recently pressed but the previous
        content is not available then get new PLC */

        this.setState({ backwardPressedAMomentAgo: false });
        selectedPLC = s[oldIndex].plHook && (await s[oldIndex].getContent());
      } else if (
        this.state.backwardPressedAMomentAgo &&
        oldIndexPreviousPlaylistContent &&
        oldIndexPreviousPlaylistContent.length > 0
      ) {
        /* If the indexed content is playlist , and if backward was recently pressed and the previous
        content is available then get the previous selected PLC */

        selectedPLC = oldIndexPreviousPlaylistContent;
      } else if (s[oldIndex].plHook) {
        /* if it is a playlist and nothing is pressed then get new PLC */
        selectedPLC = s[oldIndex].plHook && (await s[oldIndex].getContent());
      } else {
        /* if it is a content  it is handled with function -> handleContentExceptPlaylist */
      }
      if (oldIndex === s.length - 1) {
        /* if one campaign loop completes, we need to take a new PLC content hence reset backwardPressedMomentAgo */
        this.setState({ backwardPressedAMomentAgo: false });
      }
    }
    /* ///////// THE SELCTION OF PLC ENDS HERE /////////////////// */

    let playlistDuration = null;
    // For Playlist
    if (selectedPLC) {
      this.props.setPlaylistStartTime();
      this.props.handlePlaylist(
        oldIndex,
        selectedPLC,
        this.props.playlistIndex
      );
      playlistDuration = selectedPLC.reduce(
        (total, plc) => total + plc.duration,
        0
      );
      if (durn) {
        this.calculatePlaylistDuration(
          selectedPLC,
          durn,
          isForward,
          isBackward
        );
      } else {
        selectedPLC.reduce((total, plc, index) => {
          const { duration } = plc;
          let nextPlayTime;
          if (index >= this.props.playlistIndex) {
            this.props.setPlaylistStartTime();
            let newPlaylistDuration;
            if (this.props.pausedPlaylistIndex === index) {
              newPlaylistDuration =
                duration - this.props.playlistPlayedDuration;
            } else {
              this.props.resetPlaylistPlayedDuration();
              newPlaylistDuration = duration;
            }
            nextPlayTime = total + newPlaylistDuration;
            this[`playlistTimeOut-${index}`] = this.playlistTimer(
              index,
              total,
              selectedPLC
            );
            return nextPlayTime;
          }
          return 0;
        }, 0);
      }
    } else {
      this.props.handleContentExceptPlaylist(oldIndex, selectedPLC, 0);
    }

    const playDurn = selectedPLC ? playlistDuration : s[oldIndex].duration;
    if (this.props.pausedTime && this.props.pausedIndex === oldIndex) {
      const remainingDuration = playDurn - this.props.playedDuration;
      this.timeoutID = this.timer(newIndex, remainingDuration);
    } else if (durn) {
      const remainingDuration = playDurn - durn;
      this.timeoutID = this.timer(newIndex, remainingDuration);
      this.props.removeForwardTime();
    } else {
      this.props.resetPlayedDuration();
      this.timeoutID = this.timer(newIndex, playDurn);
    }
  };

  render() {
    if (
      this.props.content.length === 0 ||
      this.props.currentIndex === null ||
      this.props.isStart === 0
    ) {
      return null;
    }
    if (this.props.selectedPLC && this.props.playlistIndex !== null) {
      return this.props.selectedPLC[this.props.playlistIndex].comp;
    }
    return this.props.content[[this.props.currentIndex]].comp;
  }
}

export default Screen;
